import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type RoleFragment = { id: string, name: string, type: Types.RoleTypesEnum };


export type RoleFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const RoleFragmentDoc = /*#__PURE__*/ gql`
    fragment Role on RoleType {
  id
  name
  type
}
    `;